module.exports = __webpack_public_path__ + "static/media/paper_facory_getty_desktop.b4bdb3d6.jpg";